import { Component, OnInit, ViewChild } from '@angular/core';
import { RoutesService } from '../../services/routes.service';
import { RouteService } from '../../services/route.service';
import { CommonService } from '../../services/common.service';
import { DashboardService } from '../../services/dashboard.service';
import { SignalRService } from '../../services/signal-r.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as $ from 'jquery';
declare const google: any;
var map: any;

@Component({
  selector: 'app-route-display',
  templateUrl: './route-display.component.html',
  styleUrls: ['./route-display.component.css']
})
export class RouteDisplayComponent implements OnInit {

  filterMenuVisible: boolean = true;

  routes: any = [];
  vehicles: any = [];
  modalVehicles: any = [];
  vehiclesProcessList: any = [];
  selectedRoutes = [];
  wayPointsList = [];
  interestPointsList = [];
  routesSettings = {};

  canvasDimention: any = {}

  routeLengthInCanvas = 0;
  routeStartXInCanvas = 100;
  routeStartXInCanvasModal = 60;
  distanceXbetweenRoutes = 160;
  vehicleCavasWidth = 30;
  vehicleCavasWidthModal = 60;

  // totalVehicles: any = 0;

  vehicleAlerts: any = []


  routeLengthInCanvasModal = 3800;
  CanvasModalWid = 4000;



  alarmTypes: any = [
    { color: "#74e8f9", typeId: 1, name: "Velocidad", url :"http://www.trackingarea.com:4200/assets/img/velocityAlarmIcon.png"  },
    { color: "#c1ee74", typeId: 2, name: "Puertas Abiertas", url : "http://www.trackingarea.com:4200/assets/img/openPortsAlarmType.png"},
    { color: "#f91f1f", typeId: 3, name: "Bloqueo", url : "http://www.trackingarea.com:4200/assets/img/bockAlarmType.png"},
    { color: "#1faff9", typeId: 4, name: "Tiempo", url : "http://www.trackingarea.com:4200/assets/img/timeAlarmIcon.png"},
    { color: "#e5f534", typeId: 5, name: "Salida de Ruta", url : "http://www.trackingarea.com:4200/assets/img/outofrouteAlarmIcon.png"}
  ]
  @ViewChild('modalRouteDetail') modalRouteDetail: HTMLElement;
  constructor(
    private routeService: RouteService,
    private routesService: RoutesService,
    private commonService: CommonService,
    private dashboardService: DashboardService,
    private modalService: NgbModal,

  ) { }

  ngOnInit() {
    this.fixCanvasContenetor()
    this.routesSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'description',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };
    this.getRoutes()
    this.setTooltipCanvas();
    var signarl = new SignalRService(this);

    this.getVehicleAlerts();
  }

  getVehicleAlerts() {
    var that = this
    this.dashboardService.getLastAlertVehicles(this.commonService.getUserName()).then(obj => {

      var objJson = JSON.stringify(obj);

      for (var i = 0; i < obj.length; i++) {
        var alertList = JSON.parse(obj[i])

        for (var j in alertList.Vehicles) {
          var currentAlert = alertList.Vehicles[j]
          currentAlert = JSON.parse(currentAlert)
          currentAlert.alarmTypeId = alertList.TypeAlert

          var alertObject = that.vehicleAlerts.find(o => o.Plate === currentAlert.Plate);

          if (alertObject == undefined) {
            that.vehicleAlerts.push(currentAlert)
          } else {
            var currentDate = new Date(currentAlert.Datealert)
            var objectAlert = new Date(alertObject.Datealert)

            if (currentDate > objectAlert) {
              var objectIndex = that.vehicleAlerts.indexOf(alertObject)
              that.vehicleAlerts[objectIndex] = currentAlert
            } else {
            }
          }
        }
      }

    });
  }

  setupCanvas(canvas) {
    // Get the device pixel ratio, falling back to 1.
    var dpr = window.devicePixelRatio || 1;
    // Get the size of the canvas in CSS pixels.
    var rect = $(canvas)[0].getBoundingClientRect();
    // Give the canvas pixel dimensions of their CSS
    // size * the device pixel ratio.
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    var ctx = canvas.getContext('2d');
    // Scale all drawing operations by the dpr, so you
    // don't have to worry about the difference.
    ctx.scale(dpr, dpr);
    return ctx;
  }

  recieveNotification(data) {
    switch (data.type) {
      case "vehicleNotification":
        this.showAlertInfo(data.plate, data.notification)
        break;
    }
  }

  showAlertInfo(plate, notification) {
    var currentVehicle = this.vehicles.filter(function (item) {
      return item.Plate === plate;
    })[0];
    if (currentVehicle != undefined) {
      this.paintNotificationTooltip(currentVehicle, currentVehicle.x, currentVehicle.y, notification)
    }
  }

  fixCanvasContenetor(routesAmount = null) {

    // Calcula la altura del canvas dependiendo de la cantidad de rutas
    var canvasHeightfix = routesAmount *(this.distanceXbetweenRoutes * 1.5)

    // Trae las dimensiones actuales del canvas
    var canvasHeight = $("#routeCanvas").css("height").split("px")[0]
    if(canvasHeightfix > canvasHeight){// Se seleccionaron varias rutas y se necesita un contenedor grande
      canvasHeight = canvasHeightfix
      $("#map-content canvas").css("height", (+canvasHeight) + "px")
    }

    var canvasWidth = $("#routeCanvas").css("width").split("px")[0]


    // Setea las dimensiones del contenedor de los canvas
    $("#map-content").css("height", canvasHeight)
    //$("#map-content").css("min-width", (+canvasWidth + 200) + "px")
    $("#map-content").css("height", (+canvasHeight + 100) + "px")



    this.canvasDimention = { height: +canvasHeight, width: +canvasWidth }
    $("#routeInformation").html("")

  }

  fixModalCanvasContenetor(routesAmount = null) {
    while($(".modalwindow").length == 0){

    }
    $(".modal-content").css("min-width", "4000px")
    $(".modal-content").css("height", "600px")
    $(".modalwindow").css("overflow", "scroll")
  }

  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }

  getRoutes(): void {
    this.routesService.getRoutesByUsername(this.commonService.getUserName()).then(response => {
      if (response) {
        this.routes = []
        for (var i in response) {
          if (response[i].name == null) {
            response[i].name = "Sin Añadir"
          }
          this.routes.push({
            id: response[i].id,
            description: response[i].description + " - " + response[i].divipol_code + " - " + response[i].name
          })


        }
        this.selectedRoutes = this.routes
        this.filterRoutes()
      }
    });
  }

  cleanAllCanvas() {
    $("#routeInformation").html("")

    // Limpia los procesos de los vehiculos que hay actualmente
    for (var i in this.vehiclesProcessList) {
      clearInterval(this.vehiclesProcessList[i])
    }

    let html = "<canvas id=\"routeCanvas\" style=\"position: absolute; border:1px solid #000000; min-width:100%; margin-left:10px; right: 10px; left: 10px;\"></canvas>" +
      "<canvas id=\"routeTooltipCanvas\" style=\"position: absolute; border:1px solid #000000; min-width:100%; margin-left:10px; right: 10px; left: 10px;\"></canvas>" +
      // "<canvas id=\"vehiclesCanvas\" style=\"position: absolute; border:1px solid #000000; min-width:100%; margin-left:10px; right: 10px; left: 10px;z-index: 1;\"></canvas> " +
      "<canvas id=\"tooltipCanvas\" style=\"position: absolute; border:1px solid #000000; min-width:100%; margin-left:10px; right: 10px; left: 10px;z-index: 2;\"></canvas>"
    $("#map-content").html(html)
  }

  filterRoutes() {

    var routesId = this.selectedRoutes.map(({ id }) => id).toString();
    let that = this
    this.vehicles = []
    // this.totalVehicles = 0
    //this.vehiclesProcessList = []
    // Falta limpiar todo

    // Pide la información de las rutas que selecciona
    this.routesService.getRoutesInformation(routesId)
      .then(response => {
        that.cleanAllCanvas()
        this.fixCanvasContenetor(response.length)
        that.setTooltipCanvas();
        // Cuadrá el tamaño del canvas dependiendo de la cantidad de rutas

        let routeCanvasContext = this.setupCanvas($("#routeCanvas")[0])
        // let vehicleCanvasContext = this.setupCanvas($("#vehiclesCanvas")[0])

        let index = 0;
        for (var i in response) {
          const currentRouteTmp = response[i]


          //let currentRoutId = currentRoute.id
          // if (currentRouteTmp.route_data != "" && currentRouteTmp.route_data != null) { // tiene información geográfica
          if (currentRouteTmp.distance != "" && currentRouteTmp.distance != 0) { // tiene información geográfica
            this.drawRoute(currentRouteTmp, index, routeCanvasContext)
            index++;

            // console.log(currentRouteTmp)
            // La información geográfica

            // Actualiza la información de la ruta en la lista global de rutas
            let currentRoute = null
            let routeIndex = 0;
            for (var j = 0; j < that.routes.length; j++) {
              if (that.routes[j].id == currentRouteTmp.id) {
                that.routes[j].route_data = currentRouteTmp.route_data
                that.routes[j].rates = currentRouteTmp.rates
                that.routes[j].interestPoints = currentRouteTmp.points
                that.routes[j].name = currentRouteTmp.name
                that.routes[j].distance = currentRouteTmp.distance
                that.routes[j].divipol_code = currentRouteTmp.divipol_code
                that.routes[j].description = currentRouteTmp.description
                that.routes[j].forward_or_back = currentRouteTmp.forward_or_back
                that.routes[j].middlePoints = currentRouteTmp.middlePoints
                currentRoute = that.routes[j]
                routeIndex = j
                break
              }
            }

            if (currentRoute != null) {
              if (currentRouteTmp.distance == "" || currentRouteTmp.distance == "0"
                && currentRouteTmp.route_data != "" && currentRouteTmp.route_data != null
              ) { // No tiene la distancia actualizada
                var dataRoute = JSON.parse(currentRouteTmp.route_data.toString());
                that.routes[j].route_data = dataRoute

                this.getRouteDistance(currentRoute, currentRoute.route_data, routeIndex, routeCanvasContext)
              } else {
                this.startRoute(currentRoute, routeCanvasContext)
              }
            }

          }
        }
      });
  }

  startRoute(currentRoute, routeCanvasContext) {
    // this.paintWaypoints(currentRoute, routeCanvasContext)
    this.paintInterestPoints(currentRoute, routeCanvasContext)
    this.drawMiddlePoints(currentRoute, routeCanvasContext)

    let that = this
    this.dashboardService
      .getVehiclesByrute(this.commonService.getUserName(), currentRoute.id)
      .then(response => {
        if (response) {
          // that.totalVehicles += response.length
          that.searchVehicles(response, currentRoute)
          var processId = setInterval(async function () {
            that.searchVehicles(response, currentRoute)
          }, 30000);
          that.vehiclesProcessList.push(processId)
        }
      })
  }

  async searchVehicles(data, currentRoute) {
    // console.log(currentRoute)
    for (let i = 0; i < currentRoute.middlePoints.length; i++) {
      currentRoute.middlePoints[i].vehicles = [];
    }

    for (var i in data) {
      let dataVehicle = data[i];
      let that = this
      that.getVehicleLocation(dataVehicle, currentRoute)
    }
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  drawRoute(route, index, ctx) {
    // var color = '#' + ((1 << 24) * Math.random() | 0).toString(16);
    var color = '#000';

    this.routeLengthInCanvas = this.canvasDimention.width - 140; // el tamaño de la linea que representa una ruta


    var x1 = this.routeStartXInCanvas;
    var y1 = index * this.distanceXbetweenRoutes + this.distanceXbetweenRoutes;

    var x2 = this.routeLengthInCanvas + this.routeStartXInCanvas;
    var y2 = index * this.distanceXbetweenRoutes + this.distanceXbetweenRoutes;

    x1 -= 20
    x2 += 20

    if (route.forward_or_back == "B") {// Es una ruta de vuelta, va hacia el otro lado
      var x1 = this.routeLengthInCanvas  + this.routeStartXInCanvas;
      var y1 = index * this.distanceXbetweenRoutes + this.distanceXbetweenRoutes;

      var x2 = this.routeStartXInCanvas;
      var y2 = index * this.distanceXbetweenRoutes + this.distanceXbetweenRoutes;

      x1 += 20
      x2 -= 20
    }

    for (var i in this.routes) {
      if (this.routes[i].id == route.id) {
        this.routes[i].y = y2
      }
    }

    this.pintArrow(ctx, x1, y1, x2, y2, color);
    this.paintRouteInformation(route, 10, y1 + 10, ctx)


  }

  intersectInteresPoint(x, y, x1, x2){
    // console.log(x, x1, x2, x >= x1 && x <= x2)
    if (x > x1 && x < x2) {
      return true;
    }
    return false
  }

  drawMiddlePoints(route, ctx){
    var y = route.y
    //console.log(route)

    var pointDiameter = 10;
    route.middlePoints = []

    // Cantidad de puntos en la ruta
    var pointsAmount = (route.distance) / 2000
    pointsAmount ++

    // cantidad de area de la linea que no tendría puntos
    var distanceTotal = this.routeLengthInCanvas - (pointsAmount * pointDiameter)

    var x = this.routeStartXInCanvas + pointDiameter

    // var points = this.interestPointsList.find(x => x.id_route == route.id)
    
    for (let i = 0; i < pointsAmount; i+=1) {
      // Revisa que no se vaya a pintar sobre un punto de interes
      var intersect = false
      for (var l = 0; l < route.interestPoints.length; l++) {
        var point = route.interestPoints[l]
        if(this.intersectInteresPoint(x -(pointDiameter/2) , y, point.x - 8, point.x+8)
          || this.intersectInteresPoint(x - (pointDiameter/2) + pointDiameter, y, point.x -8, point.x+8))
          {// ninguna parte del circulo toca un triangulo
            intersect = true;
          }
      }

      if(!intersect){
        ctx.beginPath();
        ctx.arc(x, y - (pointDiameter/2) -5, pointDiameter, pointDiameter, 0, Math.PI*2);
        ctx.stroke();
        route.middlePoints.push({
          x : x, 
          y: y, 
          diameter : pointDiameter, 
          kilometer: i*2,
          vehicles : []
        })
      }
      
      x += (distanceTotal / pointsAmount) + pointDiameter

    }
  }

  pintArrow(context, fromx, fromy, tox, toy, col) {
    context.beginPath();
    context.strokeStyle = col;
    context.fillStyle = col;

    var headlen = 10; // length of head in pixels
    var dx = tox - fromx;
    var dy = toy - fromy;
    var angle = Math.atan2(dy, dx);
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
    context.moveTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));

    context.stroke();
  }

  async getVehicleLocation(vehicle, route) {
    this.dashboardService
      .getSingleVehicleLocation_inTransit(vehicle.Plate)
      .then(response => {
        if (response.length > 0) {
          vehicle.locationInfo = response[0]
          vehicle.customPlate = response[0].TrackerName

          var currentRoute = this.routes.find(r => r.id === route.id);
          currentRoute.postitionData = route.routeOrigin;
          currentRoute.route_data = route.route_data

          let journeyFix = +vehicle.locationInfo.JourneyString

          var distanceFromStart2 = Math.abs(vehicle.Distance_from_start - journeyFix)
          vehicle.distance = distanceFromStart2

          this.paintVehicle(route, vehicle, Math.round(distanceFromStart2))

        }
      });
  }

  getRouteDistance(route, routeData, routeIndex, routeCanvasContext) {
    var origin1 = new google.maps.LatLng(routeData.origin.originLat, routeData.origin.originLng);
    var destinationB = new google.maps.LatLng(routeData.destination.destinationLat, routeData.destination.destinationLng);
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin1],
        destinations: [destinationB],
        travelMode: 'DRIVING',
        // transitOptions: TransitOptions,
        // drivingOptions: DrivingOptions,
        // unitSystem: UnitSystem,
        avoidHighways: true,
        avoidTolls: true,
      }, callback);

    var that = this;

    // Cuando llega la respuesta con la distancia
    function callback(response, status) {
      if (response.rows && response.rows.length > 0) {
        if (response.rows[0].elements && response.rows[0].elements.length > 0) {
          if (response.rows[0].elements[0].distance) {

            var distance = response.rows[0].elements[0].distance.value
            //route.realDistance = distance;

            // Actualiza la distancia de la ruta en la lista global de rutas
            that.routes[routeIndex].distance = distance
            let currentRoute = that.routes[routeIndex]

            that.startRoute(currentRoute, routeCanvasContext)
            that.updateRouteDistance(currentRoute)
          }

        }

      }
    }

  }

  async updateRouteDistance(route) {
    let routeObject = {
      Id: route.id,
      Distance: route.distance
    }
    this.routeService.updateRouteDistance(routeObject)
      .then(response => {

      })
  }

  getWayPointDistance(route, routeIndex, startWayPoint, endtWayPoint, routeCanvasContext) {

    var origin1 = new google.maps.LatLng(route.route_data.origin.originLat, route.route_data.origin.originLng);
    var destinationB = new google.maps.LatLng(startWayPoint[0], startWayPoint[1]);
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin1],
        destinations: [destinationB],
        travelMode: 'DRIVING',
        // transitOptions: TransitOptions,
        // drivingOptions: DrivingOptions,
        // unitSystem: UnitSystem,
        avoidHighways: true,
        avoidTolls: true,
      }, getWayPointDistanceCalback);

    var that = this;

    // Cuando llega la respuesta con la distancia
    function getWayPointDistanceCalback(response, status) {
      if (response.rows && response.rows.length > 0) {
        if (response.rows[0].elements && response.rows[0].elements.length > 0) {
          if (response.rows[0].elements[0].distance) {

            var distanceFromStartOfRoute = response.rows[0].elements[0].distance.value

            that.getWayPointSelfDistance(route,
              routeIndex,
              startWayPoint,
              endtWayPoint,
              routeCanvasContext,
              distanceFromStartOfRoute)


          }

        }

      }
    }

  }

  async getWayPointSelfDistance(route, routeIndex, startWayPoint, endtWayPoint, routeCanvasContext, distanceFromStartOfRoute) {
    var origin1 = new google.maps.LatLng(startWayPoint[0], startWayPoint[1]);
    var destinationB = new google.maps.LatLng(endtWayPoint[0], endtWayPoint[1]);
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin1],
        destinations: [destinationB],
        travelMode: 'DRIVING',
        // transitOptions: TransitOptions,
        // drivingOptions: DrivingOptions,
        // unitSystem: UnitSystem,
        avoidHighways: true,
        avoidTolls: true,
      }, callback);

    let that = this
    function callback(response, status) {
      if (response.rows && response.rows.length > 0) {
        if (response.rows[0].elements && response.rows[0].elements.length > 0) {
          if (response.rows[0].elements[0].distance) {
            var distanceFromStartOfWayPoint = response.rows[0].elements[0].distance.value

            that.drawWayPoint(route, distanceFromStartOfRoute, distanceFromStartOfWayPoint, routeCanvasContext)
          }
        }
      }
    }
  }

  drawWayPoint(route, distanceFromStartOfRoute, distanceFromStartOfWayPoint, routeCanvasContext) {
    // Calcula la distancia del inicio del tramo
    let realDistanceFromRoute_percent = Math.round(distanceFromStartOfRoute / route.distance * 100);
    let startOfWayPointInCanvas = Math.round(this.routeLengthInCanvas * realDistanceFromRoute_percent / 100)
    startOfWayPointInCanvas += this.routeStartXInCanvas;


    // Calcula la distancia del fin del tramo
    let realDistanceOfWaypoint_percent = Math.round(distanceFromStartOfWayPoint / route.distance * 100);
    let endtOfWayPointInCanvas = Math.round(this.routeLengthInCanvas * realDistanceOfWaypoint_percent / 100)
    endtOfWayPointInCanvas += this.routeStartXInCanvas + startOfWayPointInCanvas;

    if (endtOfWayPointInCanvas > this.routeLengthInCanvas + this.routeStartXInCanvas) {
      endtOfWayPointInCanvas = this.routeLengthInCanvas + this.routeStartXInCanvas
    }


    routeCanvasContext.beginPath();
    routeCanvasContext.strokeStyle = "#000";
    routeCanvasContext.fillStyle = "#000";

    routeCanvasContext.moveTo(startOfWayPointInCanvas, route.y);
    routeCanvasContext.lineTo(endtOfWayPointInCanvas + 20, route.y);

    routeCanvasContext.stroke();
  }

  async paintWaypoints(route, routeCanvasContext) {
    if (route.rates.length > 0) {
      for (var i = 0; i < route.rates.length; i++) {
        if (route.rates[i].lat != "" && route.rates[i].lng != "") {
          let startTram = route.rates[i].lat.split("_")
          let endTram = route.rates[i].lat.split("_")
          this.getWayPointDistance(route, i, startTram, endTram, routeCanvasContext)
        }
      }
    }
  }

  paintInterestPoints(route, routeCanvasContext) {
    if (route.interestPoints.length > 0) {
      for (var i = 0; i < route.interestPoints.length; i++) {
        let currentPoint = route.interestPoints[i]
        this.drawInterestPoint(route, currentPoint, routeCanvasContext)
      }
    }
  }

  

  drawInterestPoint(route, currentPoint, routeCanvasContext) {
    // Calcula la distancia del inicio del tramo
    let realDistanceFromRoute_percent = Math.round((currentPoint.distance_from_start / route.distance) * 100);

    let XPointInCanvas = Math.round((this.routeLengthInCanvas * realDistanceFromRoute_percent) / 100)
    XPointInCanvas += this.routeStartXInCanvas;

    if (route.forward_or_back == "B") {// Es una ruta de vuelta
      XPointInCanvas = (this.routeStartXInCanvas + this.routeLengthInCanvas) - XPointInCanvas
      XPointInCanvas += (this.routeStartXInCanvas /2)
    }
    this.drawTriangle(XPointInCanvas, route.y, 15, 30, routeCanvasContext)

    var y = route.y - 30
    for (let i = 0; i < 4; i++) {
      // routeCanvasContext.rotate(-0.5*Math.PI);
      // routeCanvasContext.save();
      // routeCanvasContext.translate(100,300);
      // routeCanvasContext.rotate(-0.5*Math.PI);
      routeCanvasContext.fillText(currentPoint.name.substring(i,i+1), XPointInCanvas - 4, y);
      y -= 10
      // routeCanvasContext.restore();
    }

    // var imageObj = new Image();
    // imageObj.onload = function () {
    //   routeCanvasContext.drawImage(this, XPointInCanvas, route.y - 15, 15, 15);
    // };
    // imageObj.src = "http://www.trackingarea.com:4200/assets/img/interestPoint.png";


    //context.fillText(string, x, y);

    currentPoint.x = +XPointInCanvas
    currentPoint.y = +route.y// - 20
    currentPoint.id_route = route.id

    this.interestPointsList.push(currentPoint)
  }


  drawTriangle(x, y, width, height, context){
    context.strokeStyle = '#00b0f0';
    context.lineWidth = 1.5;
    context.beginPath();

    context.moveTo(x -(width/2), y);

    context.lineTo(x, y-height);
    context.lineTo(x +(width/2), y);
    context.lineTo(x -(width/2), y);

    context.closePath();
    context.stroke();
    context.lineWidth = 1;
    context.strokeStyle = '#000';
  }


  setSingleVehicleCanvas(plate) {
    let canvasId = plate + "_canvas";

    if ($("#" + canvasId).length == 0) // existe el canvas para ese vehiculo en el dom
    {// Lo crea
      let canvasHtml = "<canvas id=" + canvasId + " style=\"position: absolute; border:1px solid #000000; min-width:100%; margin-left:10px; right: 10px; left: 10px;\"></canvas>"
      $("#map-content").append(canvasHtml)
      $("#" + canvasId).css("height", (+this.canvasDimention.height) + "px")

    }

    return this.setupCanvas($("#" + canvasId)[0])
  }

  async getVehicleDistance(route, vehicle, context) {
    var origin1 = new google.maps.LatLng(route.route_data.origin.originLat, route.route_data.origin.originLng);
    // var origin2 = 'Greenwich, England';
    // var destinationA = 'Stockholm, Sweden';
    var destLat = vehicle.locationInfo.Latitude.replace(",", ".")
    var destLng = vehicle.locationInfo.Longitude.replace(",", ".")
    var destinationB = new google.maps.LatLng(destLat, destLng);
    var that = this;
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin1],
        destinations: [destinationB],
        travelMode: 'DRIVING',
        // transitOptions: TransitOptions,
        // drivingOptions: DrivingOptions,
        // unitSystem: UnitSystem,
        avoidHighways: true,
        avoidTolls: true,
      }, callback);

    function callback(response, status) {
      if (response != null && response.rows && response.rows.length > 0) {
        if (response.rows[0].elements && response.rows[0].elements.length > 0) {
          if (response.rows[0].elements[0].distance) {

            var distanceFromStart = response.rows[0].elements[0].distance.value
            vehicle.distance = response.rows[0].elements[0].distance.text
            vehicle.remain = response.rows[0].elements[0].duration.text

            that.paintVehicle(route, vehicle, distanceFromStart)
          }
        }
      }
    }



  }

  findMiddlePoint(route, vehicle){
    var currentMiddlePoint = null
    var vehiclePositionInMiddlePoint = 0
    var nextMiddlePointKilometer = 2 * Math.round((vehicle.distance/ 1000) / 2)
    
    for (var i in route.middlePoints) {
      var point = route.middlePoints[i]
      if(point.kilometer == nextMiddlePointKilometer)
      {
        point.vehicles.push(vehicle.customPlate)
        
        route.middlePoints[i] = point
        currentMiddlePoint = point
        
        vehiclePositionInMiddlePoint = point.vehicles.length -1
        break
      }
    }
    

    if(currentMiddlePoint == null){
      vehicle.distance -= 2000
      return this.findMiddlePoint(route, vehicle)
    }

    return [vehiclePositionInMiddlePoint, currentMiddlePoint]
  }
  async paintVehicle(route, vehicle, distance) {

    let context = this.setSingleVehicleCanvas(vehicle.Plate)
    //let vehicleIconUrl = this.getLastAlert(vehicle, route)
    let vehicleColor = this.getLastAlert(vehicle, route)

    // Calcula el porcentaje de la ruta que ha recorrido el vehiculo
    var realDistance_percent = Math.round(distance / route.distance * 100);
    if (realDistance_percent > 100) {
      realDistance_percent = 100
    }
    vehicle.percent = realDistance_percent;

    // Calcula el x en la line que representa la ruta
    var vehiclePositionInCanvas = Math.round(this.routeLengthInCanvas * realDistance_percent / 100)
    vehiclePositionInCanvas += this.routeStartXInCanvas;
    vehicle.x = vehiclePositionInCanvas// - 15

    
    if (route.forward_or_back == "B") {// Es una ruta de vuelta, invierte la posición
      vehicle.x = (this.routeStartXInCanvas + this.routeLengthInCanvas) - vehiclePositionInCanvas
      vehicle.x += (this.routeStartXInCanvas /2)
    }
    
    // Actualiza datos
    vehicle.y = route.y - 15
    vehicle.routeName = route.name
    vehicle.routeDescription = route.description
    this.storeVehicle(vehicle)

    // Busca el actual punto de la ruta donde debe ser pintado, y actualiza la ruta
    var middlePointData = this.findMiddlePoint(route, vehicle);
    var vehiclePositionInMiddlePoint = middlePointData[0]
    var currentMiddlePoint = middlePointData[1]

    if(currentMiddlePoint != null){
      context.strokeStyle = vehicleColor;
      context.fillStyle = vehicleColor;


      if(vehiclePositionInMiddlePoint == 0)
      {// pinta el circulo, y añade el número
        //tooltipCtx.font = tooltipCtx.font.replace(/\d+px/, "8.5px");

        context.beginPath();
        context.arc(currentMiddlePoint.x , currentMiddlePoint.y- (currentMiddlePoint.diameter/2)-5, currentMiddlePoint.diameter, currentMiddlePoint.diameter, 0, Math.PI*2);
        context.fill();

        // context.font = "11px Arial";
        console.log(vehicle.customPlate)
        context.fillText(vehicle.customPlate, currentMiddlePoint.x - 8,  currentMiddlePoint.y - 25);

      }else{
        // añade el número 
        context.fillText(vehicle.customPlate, currentMiddlePoint.x -8, currentMiddlePoint.y- (vehiclePositionInMiddlePoint * 10) - 25);
      }

      var index = this.routes.indexOf(route)
      this.routes[index] = route
      
      context.strokeStyle = "#000";
      context.fillStyle = "#000";
    }
    

    // console.log(this.routes)
    // var that = this
    // var imageObj = new Image();
    // imageObj.onload = function () {
    //   context.drawImage(this, vehicle.x, vehicle.y, that.vehicleCavasWidth, that.vehicleCavasWidth);
    // };
    // context.fillText(vehicle.customPlate, vehicle.x + 3, vehicle.y);
    // imageObj.src = vehicleIconUrl;

    console.log("Actualizado", vehicle.percent, vehicle.customPlate, route.description, vehicle.x, vehicle.y, vehicle.distance / 1000, 2 * Math.round((vehicle.distance/ 1000) / 2))

  }

  storeVehicle(vehicle){
    // busca el vehiculo en la lista
    let currentVehicle = null
    for (var i in this.vehicles) {
      if (this.vehicles[i].Plate == vehicle.Plate) {// lo encuentra y lo actualiza
        currentVehicle = this.vehicles[i]
        this.vehicles[i] = vehicle
        break
      }
    }
    // No encontro el vehiculo en la lista
    if (currentVehicle == null) {
      this.vehicles.push(vehicle) // completa la información y lo agrega a la lista
    }

    // Lo guarda localmente para ser usado en el dashboard
    localStorage.setItem("vehiclesInTransit",JSON.stringify(this.vehicles))

  }

  getLastAlert(vehicle, route) {
    var alertObject = this.vehicleAlerts.find(o => o.Plate === vehicle.Plate);

    var iconUrl = "#000"
    // if (route.forward_or_back == "B") {// Es una ruta de vuelta
    //   iconUrl = "http://www.trackingarea.com:4200/assets/img/bus_autobus-512_back.png"
    // }

    if(alertObject != undefined){

      switch (alertObject.alarmTypeId) {
        case 1:
          iconUrl = "http://www.trackingarea.com:4200/assets/img/velocityAlarmIcon.png"
          iconUrl = "#74E8F9"
          break;
        case 2:
          iconUrl = "http://www.trackingarea.com:4200/assets/img/openPortsAlarmType.png"
          iconUrl = "#0E0E0E"
          break;
        case 3:
          iconUrl = "http://www.trackingarea.com:4200/assets/img/bockAlarmType.png"
          iconUrl = "#0E0E0E"
          break;
        case 4:
          iconUrl = "http://www.trackingarea.com:4200/assets/img/timeAlarmIcon.png"
          iconUrl = "#0E0E0E"
          break;
        case 5:
          iconUrl = "http://www.trackingarea.com:4200/assets/img/outofrouteAlarmIcon.png"
          iconUrl = "#0E0E0E"
          break;
      }
    }

    return iconUrl;
  }

  paintPermanentAlertModel(vehicle, vehicleCanvasContext, y) {
    var alertObject = this.vehicleAlerts.find(o => o.Plate === vehicle.Plate);

    var iconUrl = ""
    switch (alertObject.alarmTypeId) {
      case 1:
        iconUrl = "http://www.trackingarea.com:4200/assets/img/velocityAlarmIcon.png"
        break;
      case 2:
        iconUrl = "http://www.trackingarea.com:4200/assets/img/openPortsAlarmType.png"
        break;
      case 3:
        iconUrl = "http://www.trackingarea.com:4200/assets/img/bockAlarmType.png"
        break;
      case 4:
        iconUrl = "http://www.trackingarea.com:4200/assets/img/timeAlarmIcon.png"
        break;
      case 5:
        iconUrl = "http://www.trackingarea.com:4200/assets/img/outofrouteAlarmIcon.png"
        break;
    }

    var imageObj = new Image();
    imageObj.onload = function () {
      vehicleCanvasContext.drawImage(this, vehicle.x, y - 40, 25, 25);
    };
    imageObj.src = iconUrl;
  }

  cleanRouteCanvas(context) {
    context.clearRect(0, 0, this.canvasDimention.width, this.canvasDimention.height);
  }

  cleanTooltipCanvas() {
    var canvasElement = $("#tooltipCanvas")
    var context = canvasElement[0].getContext("2d");
    context.clearRect(0, 0, this.canvasDimention.width, this.canvasDimention.height);
  }

  cleanTooltipCanvasModel() {
    var canvasElement = $("#tooltipCanvas-modal")
    var context = canvasElement[0].getContext("2d");
    context.clearRect(0, 0, this.canvasDimention.width, this.canvasDimention.height);
  }

  paintVehicleTooltip(vehicle, x, y) {
    // var canvasElement = $("#tooltipCanvas")
    // var context = canvasElement[0].getContext("2d");
    var context = this.setupCanvas($("#tooltipCanvas")[0])


    context.font = "10px Arial";

    var lineheight = 10;

    var vehicleText = {
      Placa: vehicle.customPlate,
      Recorrido: vehicle.percent + "%",
      Distancia: (vehicle.distance / 1000).toFixed(2) + " Km",
      // Restante: vehicle.remain
    }

    var width = this.getLargerTextSize(vehicleText, context) + 10
    var height = (Object.keys(vehicleText).length * lineheight) + 5 // La cantidad de lineas de texto

    var response = this.checkCanvasLimits(x, y, width, height, $("#tooltipCanvas"))
    x = response.x
    y = response.y

    context.fillStyle = "black";
    context.fillRect(x - 5, y - 10, width, height);

    context.fillStyle = "#fff";
    //tooltipCtx.font = tooltipCtx.font.replace(/\d+px/, "8.5px");
    for (var key in vehicleText) {
      var string = key + ": " + vehicleText[key]
      context.fillText(string, x, y);
      y += lineheight
    }
  }

  paintVehicleTooltipModal(vehicle, x, y) {
    // var canvasElement = $("#tooltipCanvas")
    // var context = canvasElement[0].getContext("2d");
    var context = this.setupCanvas($("#tooltipCanvas-modal")[0])


    context.font = "15px Arial";

    var lineheight = 20;

    var vehicleText = {
      Placa: vehicle.customPlate,
      Recorrido: vehicle.percent + "%",
      Distancia: (vehicle.distance / 1000).toFixed(2) + " Km",
      // Restante: vehicle.remain
    }

    var width = this.getLargerTextSize(vehicleText, context) + 15
    var height = (Object.keys(vehicleText).length * lineheight) + 30 // La cantidad de lineas de texto

    var response = this.checkCanvasLimits(x, y, width, height, $("#tooltipCanvas-modal"))
    x = response.x
    y = response.y  - 100

    context.fillStyle = "black";
    context.fillRect(x - 5, y-lineheight, width, height);

    context.fillStyle = "#fff";
    //tooltipCtx.font = tooltipCtx.font.replace(/\d+px/, "8.5px");
    for (var key in vehicleText) {
      var string = key + ": " + vehicleText[key]
      context.fillText(string, x, y+5);
      y += lineheight
    }
  }

  paintNotificationTooltip(vehicle, x, y, notification) {
    // var canvasElement = $("#tooltipCanvas")
    // var context = canvasElement[0].getContext("2d");
    var plate = vehicle.Plate

    // var context = this.setupCanvas($("#" + plate + "_canvas")[0])
    var context = this.setupCanvas($("#notificationCanvas")[0])


    context.font = "18px Arial";

    var lineheight = 10;

    var vehicleText = {
      Placa: vehicle.Plate,
      // Recorrido: vehicle.percent + "%",
      // Distancia: (vehicle.distance / 1000).toFixed(2) + " Km",
      Alerta: notification.description
      // Restante: vehicle.remain
    }

    var width = this.getLargerTextSize(vehicleText, context) + 10
    var height = (Object.keys(vehicleText).length * lineheight) + 5 // La cantidad de lineas de texto

    var response = this.checkCanvasLimits(x, y - 30, width, height, $("#notificationCanvas"))
    x = response.x
    y = response.y

    context.fillStyle = "black";
    context.fillRect(x - 5, y - 10, width, height);

    context.fillStyle = "#fff";
    //tooltipCtx.font = tooltipCtx.font.replace(/\d+px/, "8.5px");
    for (var key in vehicleText) {
      var string = key + ": " + vehicleText[key]
      context.fillText(string, x, y);
      y += lineheight
    }
  }


  paintInterestPointTooltip(interestPoint, x, y) {
    // var canvasElement = $("#tooltipCanvas")
    // var context = canvasElement[0].getContext("2d");
    var context = this.setupCanvas($("#tooltipCanvas")[0])



    var lineheight = 10;

    var pointText = {
      Nombre: interestPoint.name,
      Distancia: (interestPoint.distance_from_start / 1000).toFixed(2) + " Km"
    }

    var width = this.getLargerTextSize(pointText, context) + 10
    var height = (Object.keys(pointText).length * lineheight) + 5 // La cantidad de lineas de texto

    var response = this.checkCanvasLimits(x, y, width, height, $("#tooltipCanvas"))
    x = response.x
    y = response.y

    context.fillStyle = "white";
    context.fillRect(x - 5, y - 10, width, height + 15);

    context.fillStyle = "#000";
    //tooltipCtx.font = tooltipCtx.font.replace(/\d+px/, "8.5px");
    context.font = "11px Arial";
    context.fillText("Punto de Interes: ", x, y);
    y += lineheight


    context.font = "10px Arial";
    for (var key in pointText) {
      var string = key + ": " + pointText[key]
      context.fillText(string, x, y);
      y += lineheight
    }
  }

  paintRouteTooltip(route, x, y) {
    // var canvasElement = $("#tooltipCanvas")
    // var context = canvasElement[0].getContext("2d");
    var context = this.setupCanvas($("#routeTooltipCanvas")[0])
    context.font = "12px Arial";



    var lineheight = 12;

    var pointText = {
      Ruta: route.description + " - " + route.divipol_code,
      Distancia: (route.distance / 1000).toFixed(2) + " Km"
    }

    var width = this.getLargerTextSize(pointText, context) + 12
    var height = (Object.keys(pointText).length * lineheight) + 6 // La cantidad de lineas de texto

    var response = this.checkCanvasLimits(this.routeStartXInCanvas, y, width, height, $("#routeTooltipCanvas"))
    x = response.x
    y = response.y

    context.fillStyle = "white";
    context.fillRect(x - 5, y - 15, width, height + 15);

    context.fillStyle = "#000";
    //tooltipCtx.font = tooltipCtx.font.replace(/\d+px/, "8.5px");

    for (var key in pointText) {
      var string = key + ": " + pointText[key]
      context.fillText(string, x, y);
      y += lineheight
    }
  }

  paintRouteInformation(route, x, y, context) {
    // var canvasElement = $("#tooltipCanvas")
    // var context = canvasElement[0].getContext("2d");
    // var context = this.setupCanvas($("#routeTooltipCanvas")[0])
    context.font = "10px Arial";



    var lineheight = 10;

    var pointText = {
      Ruta: route.name,
      Distancia: (route.distance / 1000).toFixed(2) + " Km"
    }

    // var width = this.getLargerTextSize(pointText, context) + 12
    // var height = (Object.keys(pointText).length * lineheight) + 6 // La cantidad de lineas de texto

    // var response = this.checkCanvasLimits(this.routeStartXInCanvas, y, width, height, $("#routeTooltipCanvas"))
    // x = response.x
    // y = response.y

    //context.fillStyle = "white";
    //context.fillRect(x - 5, y - 15, width, height + 15);

    //tooltipCtx.font = tooltipCtx.font.replace(/\d+px/, "8.5px");
    y -= 100
    x -= 5

    context.fillStyle = "#000";
    //context.fillText("Ruta", x, y);
    //y += lineheight
    context.fillText("Ruta: ", x, y);
    y += lineheight
    context.fillText(route.name.substring((route.name.length/2), route.name.length), x, y);
    y += lineheight
    context.fillText(route.name.substring(0, (route.name.length/2)), x, y);
    y += lineheight
    context.fillText("Dist: " + (route.distance / 1000).toFixed(2) + " Km", x, y);
    // for (var key in pointText) {
    //   var string = key + ": " + pointText[key]
    //   context.fillText(string, x, y);
    //   y += lineheight
    // }
  }

  getLargerTextSize(vehicle, tooltipCtx) { // Devuelve el tamaño de la linea de texto más larga
    var size = 0
    for (var key in vehicle) {
      var string = key + ": " + vehicle[key]
      var width = tooltipCtx.measureText(string).width;

      if (width > size) {
        size = width
      }
    }
    return size
  }

  checkCanvasLimits(x, y, width, height, tooltipCtx) {
    if (x + width > tooltipCtx.width) {
      x = x - width
    }
    if (y + height > tooltipCtx.height) {
      y = y - height
    }
    return { x: x, y: y }
  }

  setTooltipCanvas() {
    var that = this
    // $("#tooltipCanvas").mousemove(function (event) {
    //   // that.cleanTooltipCanvas()
    //   //var canvas = document.getElementById('canvasMap');
    //   //var ctx = canvas.getContext("2d");


    //   let tooltipCanvas = $("#tooltipCanvas")[0]
    //   // let tooltipCtx = tooltipCanvas[0].getContext("2d");

    //   var dpr = window.devicePixelRatio || 1;
    //   // Get the size of the canvas in CSS pixels.
    //   var rect = $(tooltipCanvas)[0].getBoundingClientRect();
    //   // Give the canvas pixel dimensions of their CSS
    //   // size * the device pixel ratio.
    //   tooltipCanvas.width = rect.width * dpr;
    //   tooltipCanvas.height = rect.height * dpr;
    //   var ctx = tooltipCanvas.getContext('2d');
    //   // Scale all drawing operations by the dpr, so you
    //   // don't have to worry about the difference.
    //   ctx.scale(dpr, dpr);


    //   let x = (event.clientX - rect.left) / (rect.right - rect.left) * tooltipCanvas.width;
    //   let y = (event.clientY - rect.top) / (rect.bottom - rect.top) * tooltipCanvas.height;

    //   // console.log(x, y)
    //   that.searchVehicleForTooltip(x, y)
    //   that.searchInterestPointForTooltip(x, y)
    //   // that.searchRouteForTooltip(x, y)
    // });


    // $("#tooltipCanvas").dblclick(function (event) {
    //   // that.cleanTooltipCanvas()

    //   let tooltipCanvas = $("#tooltipCanvas")[0]

    //   var dpr = window.devicePixelRatio || 1;
    //   var rect = $(tooltipCanvas)[0].getBoundingClientRect();

    //   // Give the canvas pixel dimensions of their CSS
    //   // size * the device pixel ratio.
    //   tooltipCanvas.width = rect.width * dpr;
    //   tooltipCanvas.height = rect.height * dpr;
    //   var ctx = tooltipCanvas.getContext('2d');

    //   // Scale all drawing operations by the dpr, so you
    //   // don't have to worry about the difference.
    //   ctx.scale(dpr, dpr);

    //   let x = (event.clientX - rect.left) / (rect.right - rect.left) * tooltipCanvas.width;
    //   let y = (event.clientY - rect.top) / (rect.bottom - rect.top) * tooltipCanvas.height;

    //   that.searchRouteForDblclick(x, y)
    // });
  }

  setTooltipCanvasModal() {
    var that = this
    $("#tooltipCanvas-modal").mousemove(function (event) {
      // that.cleanTooltipCanvasModel()
      //var canvas = document.getElementById('canvasMap');
      //var ctx = canvas.getContext("2d");


      let tooltipCanvas = $("#tooltipCanvas-modal")[0]
      // let tooltipCtx = tooltipCanvas[0].getContext("2d");

      var dpr = window.devicePixelRatio || 1;
      // Get the size of the canvas in CSS pixels.
      var rect = $(tooltipCanvas)[0].getBoundingClientRect();
      // Give the canvas pixel dimensions of their CSS
      // size * the device pixel ratio.
      tooltipCanvas.width = rect.width * dpr;
      tooltipCanvas.height = rect.height * dpr;
      var ctx = tooltipCanvas.getContext('2d');
      // Scale all drawing operations by the dpr, so you
      // don't have to worry about the difference.
      ctx.scale(dpr, dpr);

      let x = (event.clientX - rect.left) / (rect.right - rect.left) * tooltipCanvas.width;
      let y = (event.clientY - rect.top) / (rect.bottom - rect.top) * tooltipCanvas.height;

      that.searchVehicleForTooltipModal(x, y)
    });


  }

  searchVehicleForTooltip(x, y) {
    let currentVehicle = null
    try {
      const diameter = this.vehicleCavasWidth;
      for (var i = 0; i < this.vehicles.length; i++) {

        // Toma la posición y crea un cuadrado para el tooltip
        var radius = (diameter / 2)
        let tmpX = this.vehicles[i].x
        let tmpY = this.vehicles[i].y
        let x1 = tmpX //- radius
        let x2 = tmpX + diameter
        let y1 = tmpY// - radius
        let y2 = tmpY + diameter

        // console.log(x + " " + x1 + " " + y + " " + y1)
        // console.log(this.routes)
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          currentVehicle = this.vehicles[i]
          break
        }
      }
    } catch (e) {
    }

    if (currentVehicle != null) {
      this.paintVehicleTooltip(currentVehicle, x, y)
    }
  }

  searchVehicleForTooltipModal(x, y) {
    let currentVehicle = null
    try {
      const diameter = this.vehicleCavasWidthModal;
      for (var i = 0; i < this.modalVehicles.length; i++) {

        // console.log(this.modalVehicles[i])
        // console.log(x, y)
        // Toma la posición y crea un cuadrado para el tooltip
        var radius = (diameter / 2)
        let tmpX = this.modalVehicles[i].x
        let tmpY = this.modalVehicles[i].y
        let x1 = tmpX //- radius
        let x2 = tmpX + diameter
        let y1 = tmpY// - radius
        let y2 = tmpY + diameter

        //console.log(x + " " + x1 + " " + y + " " + y1)
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          currentVehicle = this.modalVehicles[i]
          break
        }
      }
    } catch (e) {
    }

    if (currentVehicle != null) {
      this.paintVehicleTooltipModal(currentVehicle, currentVehicle.x, currentVehicle.y)
    }
  }


  searchInterestPointForTooltip(x, y) {
    let currentPoint = null
    try {
      const diameter = 25;
      for (var i = 0; i < this.interestPointsList.length; i++) {

        // Toma la posición y crea un cuadrado para el tooltip
        // var radius = (diameter / 2)
        let tmpX = this.interestPointsList[i].x
        let tmpY = this.interestPointsList[i].y
        let x1 = tmpX //- radius
        let x2 = tmpX + diameter
        let y1 = tmpY// - radius
        let y2 = tmpY + diameter

        //console.log(x + " " + x1 + " " + y + " " + y1)
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          currentPoint = this.interestPointsList[i]
          break
        }
      }
    } catch (e) {
    }

    if (currentPoint != null) {
      this.paintInterestPointTooltip(currentPoint, currentPoint.x, currentPoint.y)
    }
  }

  searchRouteForTooltip(x, y) {
    let currentRoute = null
    try {
      const diameter = this.routeLengthInCanvas;
      for (var i = 0; i < this.routes.length; i++) {

        // Toma la posición y crea un cuadrado para el tooltip
        // var radius = (diameter / 2)
        let tmpX = this.routeStartXInCanvas;
        let tmpY = this.routes[i].y
        let x1 = tmpX //- radius
        let x2 = tmpX + diameter
        let y1 = tmpY - this.vehicleCavasWidth / 2
        let y2 = tmpY + this.vehicleCavasWidth / 2

        //console.log(x + " " + x1 + " " + y + " " + y1)
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          currentRoute = this.routes[i]
          break
        }
      }
    } catch (e) {
    }

    if (currentRoute != null) {
      this.paintRouteTooltip(currentRoute, this.routeStartXInCanvas, currentRoute.y)
    }
  }

  searchRouteForDblclick(x, y) {
    let currentRoute = null
    try {
      const diameter = this.routeLengthInCanvas;
      for (var i = 0; i < this.routes.length; i++) {

        // Toma la posición y crea un cuadrado para el tooltip
        // var radius = (diameter / 2)
        let tmpX = this.routeStartXInCanvas;
        let tmpY = this.routes[i].y
        let x1 = tmpX //- radius
        let x2 = tmpX + diameter
        let y1 = tmpY - this.vehicleCavasWidth / 2
        let y2 = tmpY + this.vehicleCavasWidth / 2

        //console.log(x + " " + x1 + " " + y + " " + y1)
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          currentRoute = this.routes[i]
          break
        }
      }
    } catch (e) {
    }

    if (currentRoute != null) {
    const modalRfid = this.modalService.open(this.modalRouteDetail, { size: 'lg', windowClass : "modalwindow" });
    var that = this;
    var processId = setTimeout(async function () {
      that.fixModalCanvasContenetor()
      that.drawRouteInModal(currentRoute)
    }, 0);
    }
  }

  drawRouteInModal(route) {
    // var color = '#' + ((1 << 24) * Math.random() | 0).toString(16);
    var color = '#000';

    let routeCanvasContext = this.setupCanvas($("#routeCanvas-modal")[0])

    // console.log(routeCanvasContext)
    // this.routeLengthInCanvas = this.canvasDimention.width - 10; // el tamaño de la linea que representa una ruta



    var x1 = this.routeStartXInCanvasModal;
    var y1 = this.distanceXbetweenRoutes + 100;

    var x2 = this.routeLengthInCanvasModal;
    var y2 = this.distanceXbetweenRoutes + 100;

    if (route.forward_or_back == "B") {// Es una ruta de vuelta, va hacia el otro lado
      var x1 = this.routeLengthInCanvasModal;
      var y1 = this.distanceXbetweenRoutes + 100;

      var x2 = this.routeStartXInCanvasModal;
      var y2 = this.distanceXbetweenRoutes + 100;
    }

    this.pintArrow(routeCanvasContext, x1, y1, x2, y2, color);
    this.startRouteModal(route, routeCanvasContext)
  }

  startRouteModal(currentRoute, routeCanvasContext) {
    // this.paintWaypoints(currentRoute, routeCanvasContext)
    // this.paintInterestPoints(currentRoute, routeCanvasContext)

    let that = this
    this.dashboardService
      .getVehiclesByrute(this.commonService.getUserName(), currentRoute.id)
      .then(response => {
        if (response) {
          that.setTooltipCanvasModal()
          that.modalVehicles = []

          // that.totalVehicles += response.length

          // that.searchVehiclesModal(response, currentRoute)
          var processId = setTimeout(async function () {
            that.searchVehiclesModal(response, currentRoute)
          }, 0);
          //that.vehiclesProcessList.push(processId)
        }
      })
  }

  async searchVehiclesModal(data, currentRoute) {
    for (var i in data) {
      let dataVehicle = data[i];
      let that = this
      that.getVehicleLocationModal(dataVehicle, currentRoute)
    }
  }

  async getVehicleLocationModal(vehicle, route) {
    this.dashboardService
      .getSingleVehicleLocation_inTransit(vehicle.Plate)
      .then(response => {
        if (response.length > 0) {
          vehicle.locationInfo = response[0]
          vehicle.customPlate = response[0].TrackerName

          var currentRoute = this.routes.find(r => r.id === route.id);
          currentRoute.postitionData = route.routeOrigin;
          currentRoute.route_data = route.route_data

          let journeyFix = +vehicle.locationInfo.JourneyString

          var distanceFromStart2 = Math.abs(vehicle.Distance_from_start - journeyFix)
          vehicle.distance = distanceFromStart2

          this.paintVehicleModal(route, vehicle, Math.round(distanceFromStart2))

        }
      });
  }

  async paintVehicleModal(route, vehicle, distance) {
    let context = this.setSingleVehicleCanvasModal(vehicle.Plate)
    // let vehicleIconUrl = "http://www.trackingarea.com:4200/assets/img/bus_autobus-512.png"
    let vehicleIconUrl = this.getLastAlert(vehicle, route)

    var realDistance_percent = Math.round(distance / route.distance * 100);
    if (realDistance_percent > 100) {
      realDistance_percent = 100
    }
    var vehiclePositionInCanvas = Math.round(this.routeLengthInCanvasModal * realDistance_percent / 100)

    vehiclePositionInCanvas += this.routeStartXInCanvasModal;
    // vehicle.vehiclePositionInCanvas = vehiclePositionInCanvas
    vehicle.x = vehiclePositionInCanvas - 15
    vehicle.y = route.y - 15
    vehicle.percent = realDistance_percent;


    if (route.forward_or_back == "B") {// Es una ruta de vuelta
      // vehicleIconUrl = "http://www.trackingarea.com:4200/assets/img/bus_autobus-512_back.png"

      // le quita lo que le había sumado antes
      vehiclePositionInCanvas -= 90;
      vehicle.x = this.routeLengthInCanvasModal - vehiclePositionInCanvas
      // vehicle.x -= 15// Hace el efecto de restarle 15 si fuera una ruta de ida
    }


    // busca el vehiculo en la lista
    let currentVehicle = null
    for (var i in this.vehicles) {
      if (this.vehicles[i].Plate == vehicle.Plate) {// lo encuentra y lo actualiza
        // this.cleanVehicleCanvas(this.vehicles[i].x, this.vehicles[i].y, context)

        currentVehicle = this.vehicles[i]
        this.vehicles[i] = vehicle
        break
      }
    }
    // No encontro el vehiculo en la lista
    if (currentVehicle == null) {
      this.vehicles.push(vehicle) // completa la información y lo agrega a la lista
    }
    var that = this


    context.font = "15px Arial";
    var y1 = this.distanceXbetweenRoutes + 100 - 30;
    vehicle.y = y1
    if (currentVehicle != null
    ) {// Cambió la ubicación -  Limpia el recuadro anterior y actualiza
      var imageObj = new Image();
      imageObj.onload = function () {
        context.drawImage(this, vehicle.x, y1, that.vehicleCavasWidthModal, that.vehicleCavasWidthModal);
      };
      context.fillText(vehicle.customPlate, vehicle.x - 5, y1);
      imageObj.src = vehicleIconUrl;
    } else if (currentVehicle == null) { // no se ha pintado
      var imageObj = new Image();
      imageObj.onload = function () {
        context.drawImage(this, vehicle.x, y1, that.vehicleCavasWidthModal, that.vehicleCavasWidthModal);
      };
      context.fillText(vehicle.customPlate, vehicle.x - 5, y1);
      imageObj.src = vehicleIconUrl;
    }

    // this.paintPermanentAlertModel(vehicle, context, y1);
    this.modalVehicles.push(vehicle)
    //vehicle.distance = distance;
    //this.paintVehicleTooltip(vehicle, vehiclePositionInCanvas, 30 - 20 )
    console.log("Actualizado", vehicle.percent, vehicle.customPlate, route.description, vehicle.x, vehicle.y)

  }

  setSingleVehicleCanvasModal(plate) {
    let canvasId = plate + "_canvasmodal";

    if ($("#" + canvasId).length == 0) // existe el canvas para ese vehiculo en el dom
    {// Lo crea
      let canvasHtml = "<canvas id=" + canvasId + " style=\"position: absolute; border:1px solid #000000; min-width:100%; max-height: 400px; margin-left:10px; right: 10px; left: 10px;\"></canvas>"
      $("#map-contentModal").append(canvasHtml)
    }

    return this.setupCanvas($("#" + canvasId)[0])
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/route-display/route-display.component.ts